<div
  #chatContainer
  class="relative"
  [ngClass]="{
    'w-[727px] max-w-[727px] h-[380px] max-h-[380px]': !isTabViewChat,
    'w-full h-full': isTabViewChat,
  }"
>
  <div
    *ngIf="messages"
    class="h-[100%] max-h-[100%] bg-neutrals-300 p-6 grid grid-flow-row gap-1 auto-rows-min overflow-y-auto box-border relative"
    #chatListContainer
    (scroll)="onScroll()"
    [ngClass]="{
      'h-[100%] max-h-[100%]': '!isTabViewChat',
    }"
  >
    <div
      class="chat-message-item flex justify-center w-full px-3 py-2 box-border text-center text-neutrals-600 text-sm h-full"
      *ngIf="referral !== null && pageNumber === lastPage"
    >
      <div class="w-[400px] bg-[#f7f9fc] p-3">
        <ui-paragraph
          type="p10"
          mobile-type="p10"
          text-color="neutrals-700"
          font-weight="bold"
          content="La conversación se inició porque el usuario hizo clic en un anuncio o un enlace referido."
          class="mb-2"
        />
        <div class="px-3">
          <div class="flex">
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="semibold"
              content="Canal de Origen:"
              class="mr-1 italic"
            />
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="regular"
              [content]="contentText()"
              class="italic"
            />
          </div>
          <div class="flex">
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="semibold"
              content="Identificador:"
              class="mr-1 italic"
            />
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="regular"
              [content]="referral.id"
              class="italic"
            />
          </div>
          <div class="flex">
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="semibold"
              content="Enlace:"
              class="mr-1 italic"
            />

            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="regular"
              class="italic"
            >
              <a
                [href]="referral.sourceUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="text-primary-600 underline cursor-pointer"
              >
                {{ referral.sourceUrl }}
              </a>
            </ui-paragraph>
          </div>
          <div
            class="flex"
            *ngIf="referral.headLine && referral.headLine.length > 0"
          >
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="semibold"
              content="Título:"
              class="mr-1 italic"
            />
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="regular"
              [content]="referral.headLine"
              class="italic"
            />
          </div>
          <div
            class="text-start"
            *ngIf="referral.body && referral.body.length > 0"
          >
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="semibold"
              content="Descripción:"
              class="italic"
            />
            <ui-paragraph
              type="p10"
              mobile-type="p10"
              text-color="neutrals-700"
              font-weight="regular"
              [content]="referral.body"
              class="italic"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="grid gap-1 grid-flow-row"
      [ngClass]="{
        'client-message-box justify-start': message.from === 'user',
        'adviser-message-box': message.from === 'agent',
        'bot-message-box': message.from === 'bot',
        'justify-end': message.from === 'agent' || message.from === 'bot',
      }"
      *ngFor="let message of newMessageList; trackBy: trackByMessage"
    >
      @switch (message.item.content.type) {
        @case ('text') {
          <div class="chat-message-item px-3 py-2 box-border">
            <unicon-message-item
              [item]="message.item"
              [fromName]="message.fromName"
              [hasFromName]="message.showName"
            />
          </div>
        }
        @case ('image') {
          <div
            class="chat-message-item p-1 box-border grid grid-flow-row gap-1"
          >
            <div class="w-full pt-1 px-2" *ngIf="message.showName">
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
                font-weight="semibold"
                [content]="message.fromName"
              />
            </div>
            <img
              class="w-full rounded-[10px] cursor-pointer"
              [src]="message.item.content.value"
              alt="Img file sent"
              (click)="image.emit(message.item.content.value)"
            />
            <div class="w-full flex justify-end">
              <ui-paragraph
                type="p8"
                mobile-type="p8"
                text-color="neutrals-600"
                font-weight="regular"
                [content]="message.item.createdDateTime | date: 'hh:mm a'"
              />
            </div>
          </div>
        }
        @case ('file') {
          <div
            class="chat-message-item px-3 py-2 box-border grid grid-flow-row gap-1"
          >
            <div class="w-full pt-1 px-2" *ngIf="message.showName">
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
                font-weight="semibold"
                [content]="message.fromName"
              />
            </div>
            <a [href]="message.item.content.value" target="_blank">
              <ui-paragraph
                class="whitespace-normal break-words break-all underline"
                type="p12"
                mobile-type="p12"
                text-color="primary-600"
                font-weight="regular"
                [content]="message.item.content.value"
              />
            </a>
            <div class="w-full flex justify-end">
              <ui-paragraph
                type="p8"
                mobile-type="p8"
                text-color="neutrals-600"
                font-weight="regular"
                [content]="message.item.createdDateTime | date: 'hh:mm a'"
              />
            </div>
          </div>
        }
        @case ('video') {
          <div
            class="chat-message-item p-1 box-border grid grid-flow-row gap-1"
          >
            <div class="w-full pt-1 px-2" *ngIf="message.showName">
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
                font-weight="semibold"
                [content]="message.fromName"
              />
            </div>
            <video class="w-full rounded-[10px]" controls>
              <source [src]="message.item.content.value" type="video/mp4" />
              <source [src]="message.item.content.value" type="video/webm" />
              <source [src]="message.item.content.value" type="video/ogg" />

              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="critical-300"
                font-weight="regular"
                content="Lo sentimos, el navegador que estás usando no soporta la reproducción de video."
              />
            </video>
            <div class="w-full flex justify-end">
              <ui-paragraph
                type="p8"
                mobile-type="p8"
                text-color="neutrals-600"
                font-weight="regular"
                [content]="message.item.createdDateTime | date: 'hh:mm a'"
              />
            </div>
          </div>
        }
        @case ('audio') {
          <div
            class="chat-message-item p-1 box-border grid grid-flow-row gap-1 min-w-[300px]"
          >
            <div class="w-full pt-1 px-2" *ngIf="message.showName">
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
                font-weight="semibold"
                [content]="message.fromName"
              />
            </div>
            <audio class="w-full rounded-[10px]" controls>
              <source [src]="message.item.content.value" type="audio/ogg" />
              <source [src]="message.item.content.value" type="audio/mpeg" />

              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="critical-300"
                font-weight="regular"
                content="Lo sentimos, el navegador que estás usando no soporta la reproducción de audio."
              />
            </audio>
            <div class="w-full flex justify-end">
              <ui-paragraph
                type="p8"
                mobile-type="p8"
                text-color="neutrals-600"
                font-weight="regular"
                [content]="message.item.createdDateTime | date: 'hh:mm a'"
              />
            </div>
          </div>
        }
        @case ('buttons') {
          <div class="chat-message-item px-3 py-2 box-border ml-auto">
            <unicon-message-item
              [item]="message.item"
              [fromName]="message.fromName"
              [hasFromName]="message.showName"
            />
          </div>
          <div class="grid grid-flow-col gap-2">
            <button
              class="py-1 px-2 box-border bg-[#ECFFEA] rounded-[8px] flex justify-center items-center"
              *ngFor="let button of message.item.content.buttons"
            >
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="primary-400"
                font-weight="regular"
                [content]="button"
              />
            </button>
          </div>
        }
        @case ('button-click') {
          <div class="chat-message-item px-3 py-2 box-border">
            <unicon-message-item
              [item]="message.item"
              [fromName]="message.fromName"
              [hasFromName]="message.showName"
              [buttonLinkResponse]="true"
            />
          </div>
        }
        @case ('location') {
          <div
            class="chat-message-item p-1 box-border grid grid-flow-row gap-1"
          >
            <div class="w-full pt-1 px-2" *ngIf="message.showName">
              <ui-paragraph
                type="p10"
                mobile-type="p10"
                text-color="neutrals-700"
                font-weight="semibold"
                [content]="message.fromName"
              />
            </div>
            <img
              class="w-full rounded-[10px] cursor-pointer"
              [src]="message.item.content.value"
              alt="Img file sent"
              (click)="openGoogleMaps(message.item.content)"
            />
            <div class="w-full flex justify-end">
              <ui-paragraph
                type="p8"
                mobile-type="p8"
                text-color="neutrals-600"
                font-weight="regular"
                [content]="message.item.createdDateTime | date: 'hh:mm a'"
              />
            </div>
          </div>
        }
        @default {
          <div class="chat-message-item px-3 py-2 box-border">
            <unicon-message-item
              [item]="message.item"
              [fromName]="message.fromName"
              [hasFromName]="message.showName"
            />
          </div>
        }
      }
    </div>
  </div>
  <button
    *ngIf="showScrollButton"
    class="absolute bottom-6 left-1/2 -translate-x-1/2 z-50 bg-[#C7D3FA] px-2 py-2 rounded-full shadow-lg hover:bg-[#7D9DF2] transition"
    (click)="scrollBottom()"
  >
    <ui-icon
      name="chevron-down"
      size="20"
      mSize="20"
      fill="neutrals-900"
      class=""
    />
  </button>
</div>
